var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNsgAdam = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  viewBox: "0 0 1056 1056"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "NSG_ADAM_svg__a",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 792h792V0H0Z"
})))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#NSG_ADAM_svg__a)",
  transform: "matrix(1.33333 0 0 -1.33333 0 1056)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0-174.532-141.486-316.018-316.018-316.018S-632.035-174.532-632.035 0s141.486 316.017 316.017 316.017C-141.486 316.017 0 174.531 0 0",
  style: {
    fill: "#a89c33",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(711.774 398.843)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c35.258 0 63.84-28.582 63.84-63.839 0-35.258-28.582-63.84-63.84-63.84-35.257 0-63.839 28.582-63.839 63.84C-63.839-28.582-35.257 0 0 0ZM0 0v135.941",
  style: {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 40,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(394.83 576.32)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c-17.629 30.534-7.167 69.577 23.367 87.206s69.577 7.167 87.206-23.367c17.628-30.533 7.167-69.577-23.367-87.206C56.672-40.995 17.628-30.534 0 0ZM0 0l-117.729-67.971",
  style: {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 40,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(239.807 305.672)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c-17.629-30.534-56.672-40.996-87.206-23.367s-40.995 56.672-23.367 87.206c17.629 30.534 56.673 40.995 87.206 23.367C7.167 69.577 17.629 30.533 0 0ZM0 0l117.729-67.972",
  style: {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 40,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(551.707 306.742)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 43.842-75.938.051-.087c-68.35-39.467-114.243-113.1-114.243-197.7h-87.685",
  style: {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 40,
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(237.761 672.545)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 43.842 75.938.051.087c68.355-39.46 155.07-42.387 228.335-.087L316.07 0",
  style: {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 40,
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(237.712 125.17)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-87.786c-.004 78.927-40.826 155.488-114.092 197.788l43.843 75.937",
  style: {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 40,
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(711.777 398.815)"
})));
export default SvgNsgAdam;